/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './dropdown-link.stache';
import urlUtil from 'scripts/utils/url';

Component.extend({
    tag: 'dropdown-link',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            url: {
                type: 'string',
                value: '#',
            },
            target: {
                type: 'string',
                value: '_self',
            },
            title: {
                type: 'string',
                value: null,
            },
            value: {
                get() {
                    return this.attr('url');
                },
            },
            strategy: {
                type: 'string',
                value: 'same',
            },
            isActive: {
                get() {
                    const strategy = this.attr('strategy');
                    let url = this.attr('url') || '';
                    url = url.replace(/^.*\/\/[^\/]+/, '');
                    if (strategy === 'same') {
                        return urlUtil.getPathName() === url;
                    }
                    if (strategy === 'in') {
                        return (
                            urlUtil
                                .getPathName()
                                .indexOf(url.replace(/.html/g, '')) === 0
                        );
                    }
                    return false;
                },
            },
            display: {
                type: 'boolean',
                value: true,
            },
        },
    },
    events: {
        inserted(element) {
            element
                .closest('dropdown-container')
                .viewModel()
                .attr('links')
                .push(this.viewModel);

            if (this.viewModel.attr('isAnalytics')) {
                element
                    .find('.s-dropdown-list__item a')
                    .attr(
                        this.viewModel.attr('analyticsKey'),
                        this.viewModel.attr('title'),
                    );
                if (this.viewModel.attr('analyticsKeyCustom')) {
                    element
                        .find('.s-dropdown-list__item a')
                        .attr(
                            this.viewModel.attr('analyticsKeyCustom'),
                            this.viewModel.attr('analyticsKeyCustomValue'),
                        );
                }
            }
        },
        removed(element) {
            let containerItems = element
                .closest('dropdown-container')
                .viewModel()
                .attr('links');
            let elementIndex = containerItems.indexOf(this.viewModel);
            if (elementIndex !== -1) {
                containerItems.splice(elementIndex, 1);
            }
        },
    },
});
